import React from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import styles from './NavBar.module.scss'
// import { cancelAuth } from 'redux/rootSlice/rootSlice'
import { useAppDispatch } from 'redux/hooks'
import { Icon } from 'components/Icon/Icon'
import { MenuBar } from './components/MenuBar/MenuBar'
import { MENUBAR_DATA_MOCK } from 'layout/NavBar/consts'
import { Button } from 'components/Button/Button'
import { UserMenu } from './components/UserMenu/UserMenu'
import { MUNE_DATA } from './components/UserMenu/const'
import { PopupEditPage } from 'components/PopupEditPage/PopupEditPage'
import { useIsMobile } from 'hooks/useIsMobile'
import { MobileMenu } from './components/MobileMenu/MobileMenu'


export function NavBar() {
    const [showPopup, setShowPopup] = React.useState(false)
    const [mobileMenu, setMobileMenu] = React.useState(false)

    const { isMobile } = useIsMobile()
    // const dispatch = useAppDispatch()
    const navigate = useNavigate()
    const location = useLocation()

    // test data session 
    const session = true

    const pathname = String(location.pathname).split('/')[1]

    function navigateTo(link) {
        navigate(`/${link}`)
    }

    function openPopupEditPage() {
        setShowPopup(true)
    }

    function closePopupEditPage() {
        setShowPopup(false)
    }

    function navigateToPatrons() {
        window.open('http://localhost:3000/patrons', '_blank')
    }

    function navigateToCreators() {
        window.open('http://localhost:3000/creators', '_blank')
    }

    function navigateToAbout() {
        window.open('http://localhost:3000/about', '_blank')
    }

    function navigateToFaq() {
        window.open('http://localhost:3000/faq', '_blank')
    }

    function navigateToYourPage() {
        navigate('/deposit')
    }

    function navigateToLogin() {
        navigate('/login')
    }

    function navigateToSignup() {
        navigate('/signup')
    }

    function openMobileMenu() {
        setMobileMenu(true)
    }

    function closeMobileMenu() {
        setMobileMenu(false)
    }

    return (
        <>
            <div className={styles['container']}>
                <div className={styles['wrapper']}>
                    <div className={styles['logoWrapp']}>
                        {isMobile && (
                            <div onClick={openMobileMenu}>
                                <Icon name='menu' />
                            </div>
                        )}
                        <div className={styles['logo']} onClick={() => navigateTo('request')}>
                            <Icon name='drizzle' />
                        </div>
                    </div>
                    {session && <MenuBar data={MENUBAR_DATA_MOCK} />}
                </div>
                <div className={styles['wrapper']}>
                    {!session && (
                        <>
                            <Button
                                size='s'
                                type='transparent'
                                stretch={false}
                                onClick={navigateToCreators}>
                                For Creatots
                            </Button>
                            <Button
                                size='s'
                                type='transparent'
                                stretch={false}
                                onClick={navigateToPatrons}>
                                For Patrons
                            </Button>
                            <Button
                                size='s'
                                type='transparent'
                                stretch={false}
                                onClick={navigateToAbout}>
                                About
                            </Button>
                        </>
                    )}
                    {!isMobile && (
                        <Button
                            size='s'
                            type='transparent'
                            iconName='external'
                            iconRight={true}
                            stretch={false}
                            onClick={navigateToFaq}
                        >
                            FAQ
                        </Button>
                    )}
                    <div className={styles['buttons']}>
                        {session ? (
                            <>
                                {pathname !== 'deposit' && (
                                    <Button
                                        size='s'
                                        type='dark'
                                        iconName='view_32'
                                        stretch={false}
                                        onClick={navigateToYourPage}>
                                        Your page
                                    </Button>
                                )}
                                {!isMobile && (
                                    <UserMenu
                                        onOpenEditPage={openPopupEditPage} />
                                )}
                            </>
                        ) : (
                            <>
                                <Button
                                    size='s'
                                    type='border'
                                    stretch={false}
                                    onClick={navigateToLogin}>
                                    Log in
                                </Button>
                                <Button
                                    size='s'
                                    type='dark'
                                    stretch={false}
                                    onClick={navigateToSignup}>
                                    Get started
                                </Button>
                            </>
                        )}
                    </div>
                </div>
            </div >
            {showPopup && <PopupEditPage onClose={closePopupEditPage} />}
            {mobileMenu && <MobileMenu
                onClose={closeMobileMenu}
                onOpenEditPage={openPopupEditPage}
                menu={MENUBAR_DATA_MOCK}
                userData={MUNE_DATA} />}
        </>
    );
}

